export default __webpack_public_path__ + "static/media/UI-Icon-prototype-tool.c143ad80.mp4";